import { Reveal, SectionLabel } from "@/components/Reveal";
import { ASSETS, CONTACT } from "@/lib/site";

export default function KnowBrand() {
  return (
    <section
      id="brand"
      data-testid="brand-section"
      className="relative z-10 py-24 md:py-32"
    >
      <div className="mx-auto max-w-[1400px] px-5 md:px-10 grid lg:grid-cols-[0.4fr_0.6fr] gap-12 lg:gap-20">
        <div>
          <SectionLabel index="01">Know Your Brand</SectionLabel>
          <Reveal delay={0.05}>
            <p className="overline !text-[color:var(--relumia-muted)] !tracking-[0.2em] mb-3">
              A JAKS Pharma initiative
            </p>
          </Reveal>
          <div className="mt-6 relative overflow-hidden rounded-sm border border-champagne">
            <img
              src={ASSETS.glow}
              alt="Radiant, glowing skin"
              className="h-[380px] lg:h-[520px] w-full object-cover object-center"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black/40 via-transparent to-transparent" />
            <div className="absolute bottom-5 left-5 right-5 text-white">
              <div className="overline !text-white/80 mb-1">Glow from within</div>
              <div className="font-serif text-2xl font-light">Radiance, redefined</div>
            </div>
          </div>
        </div>

        <div className="max-w-2xl">
          <Reveal>
            <h2 className="font-serif font-light tracking-tight leading-[1.05] text-4xl md:text-5xl lg:text-[3.6rem] text-[color:var(--relumia-ink)]">
              Relumia is where{" "}
              <span className="italic text-gold">clinical rigour</span> meets
              the ritual of radiant skin.
            </h2>
          </Reveal>

          <Reveal delay={0.1}>
            <p className="mt-8 text-[15px] leading-relaxed text-[color:var(--relumia-muted)]">
              {CONTACT.company} is a purpose-driven pharmaceutical house dedicated
              to evidence-based skin aesthetics. We build formulations the way
              science demands — precise actives, transparent labels, and quality
              that meets pharmaceutical standards — then make them accessible to
              everyday India.
            </p>
          </Reveal>
          <Reveal delay={0.18}>
            <p className="mt-5 text-[15px] leading-relaxed text-[color:var(--relumia-muted)]">
              Relumia is our celebrated glutathione brand: a considered,
              cost-effective route to brighter, even-toned and youthful skin —
              formulated by dermatological insight, not marketing noise.
            </p>
          </Reveal>

          <div className="mt-12 grid sm:grid-cols-3 gap-px bg-champagne border border-champagne">
            {[
              ["Purpose", "Science-led skin aesthetics"],
              ["Standard", "WHO-GMP certified manufacturing"],
              ["Promise", "Effective &amp; accessible"],
            ].map(([k, v]) => (
              <div key={k} className="bg-base p-6">
                <div className="overline mb-2">{k}</div>
                <div
                  className="font-serif text-xl text-[color:var(--relumia-ink)] leading-snug"
                  dangerouslySetInnerHTML={{ __html: v }}
                />
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
